import NextLink from 'next/link';
import Button, { type ButtonProps } from '@discover-ui/button';

type LinkButtonProps = Pick<ButtonProps, 'kind' | 'round' | 'scale' | 'width'>;

export type LinkProps = React.ComponentPropsWithoutRef<typeof NextLink> & LinkButtonProps;

export default function Link({
  children,
  className,
  kind = 'link',
  round,
  scale,
  width,
  ...props
}: LinkProps) {
  return (
    <Button asChild className={className} kind={kind} round={round} scale={scale} width={width}>
      <NextLink {...props}>{children}</NextLink>
    </Button>
  );
}
